export const tableHeader = [
  'First Name',
  'Last Name',
  'Mobile Number',
  'Email',
  'Status',
  'Action'
]

export const initialState = {
  ins: '',
  branch: '',
  batch: ''
}